
<v-hover v-slot="{ hover }" open-delay="200" >
    <div class="app-side-buttons">
        <v-scale-transition>
            <div v-show="hover || permanent || showMenu">
                <inc-create-button
                    v-if       = "site"
                    :site      = "site"
                    @opend     = "onCreateOpen"
                    class      = "mb-3"
                />

                <c-menu-button
                    label      = "inc.overview.menu.export"
                    icon       = "mdi-download"
                    icon-color = "primary--text"
                    @click     = "onDownload"
                />

                <c-menu-button
                    label      = "inc.overview.menu.refresh"
                    icon       = "mdi-refresh"
                    icon-color = "primary--text"
                    @click     = "onRefresh"
                />

                <c-menu-button
                    v-if       = "incidentFlter && !incidentFlter.ignoreDeleted"
                    label      = "inc.overview.menu.filteroff"
                    icon       = "mdi-filter-outline"
                    icon-color = "primary--text"
                    @click     = "onFilterDeleted"
                />

                <c-menu-button
                    v-if       = "incidentFlter && incidentFlter.ignoreDeleted"
                    label      = "inc.overview.menu.filteron"
                    icon       = "mdi-filter"
                    icon-color = "red--text"
                    @click     = "onFilterDeleted"
                />
            </div>
       </v-scale-transition>
    </div>
</v-hover>
